/**
 * 公司
 */
import { getRequest, postRequest } from '../lib/axios';

export const companyApi = {
  /**
   * 列表
   */
  domain: (param) => {
    let host = window.location.host;
    //本地环境放开才能获取到测试数据*****
    host = host.includes('localhost') ? "jiaoyiys.icu" : host;
    param = { domain: host };
    return getRequest('/api/pc/company/domain', param);
  }
};
